import { mapMedia } from '@/services/mapMedia';
import { CorporateMedia } from '@/types';
import { getData } from '@/utils/corpo/request/getData';

export const getMedia = async (mediaUUID: string) => {
  const response = await getData<CorporateMedia>(`medias/${mediaUUID}`);

  return response && mapMedia(response);
};
